<div *ngIf="error && !toast && (error.message || error.code)" role="alert" class="alert alert-danger">
  <span *ngIf="error.message; else translationMissing" [ishServerHtml]="error.message"></span>
  <ng-template #translationMissing>
    <span [ishServerHtml]="error.code | translate"></span>
  </ng-template>
</div>
